var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.sessions, function (item) {
      return item.to != _vm.$store.state.user.loginId
        ? _c(
            "li",
            {
              key: item.id,
              ref: item.id + "Ref",
              refInFor: true,
              staticClass:
                "d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover",
            },
            [
              !_vm.value ||
              (_vm.value &&
                ((item.userInfo.name &&
                  item.userInfo.name.includes(_vm.value)) ||
                  (item.userInfo.userName &&
                    item.userInfo.userName.includes(_vm.value)) ||
                  (item.userInfo.nickName &&
                    item.userInfo.nickName.includes(_vm.value)) ||
                  (item.userInfo.mobile &&
                    item.userInfo.mobile.includes(_vm.value))))
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover h-67 p-relative",
                    },
                    [
                      item.scene === "p2p"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-table-cell v-a-middle h-100-p w-64",
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              item.to.length == 32
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                                      staticStyle: {
                                        "background-color": "#653EB3",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getShortNickname(
                                            item.userInfo.nickName ||
                                              item.userInfo.nick
                                              ? item.userInfo.nickName ||
                                                  item.userInfo.nick
                                              : item.userInfo.mobile
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _c("img", {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: require("@/assets/images/im/kefu.svg"),
                                    },
                                  }),
                            ]
                          )
                        : _vm._e(),
                      item.scene === "team" && item.userInfo.serverCustom
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-table-cell v-a-middle h-100-p w-64",
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              item.userInfo.avatar
                                ? _c("img", {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                    attrs: { src: item.userInfo.avatar },
                                  })
                                : _c("img", {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: require("@/assets/images/im/zhuanShu@2x.png"),
                                    },
                                  }),
                            ]
                          )
                        : _vm._e(),
                      item.scene === "team" && !item.userInfo.serverCustom
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-table-cell v-a-middle h-100-p w-64 t-a-center",
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "40px", height: "40px" },
                                attrs: {
                                  src: require("@/assets/images/im/team-cus.png"),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "p-relative d-table-cell v-a-middle h-100-p",
                        },
                        [
                          _c(
                            "div",
                            { style: { width: _vm.listWidth + "px" } },
                            [
                              item.scene === "p2p"
                                ? _c("div", [
                                    item.to.length == 32
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "t-ellipsis l-h-1-6-em m-r-10",
                                            attrs: {
                                              "data-type": JSON.stringify(item),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.userInfo.nickName ||
                                                  item.userInfo.nick
                                                  ? item.userInfo.nickName ||
                                                      item.userInfo.nick
                                                  : item.userInfo.mobile
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "p",
                                          {
                                            staticClass:
                                              "t-ellipsis l-h-1-6-em m-r-10",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.userInfo.userName || ""
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.userInfo.userName,
                                                    expression:
                                                      "item.userInfo.userName",
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.userInfo.stationName
                                                      ? "-" +
                                                          item.userInfo
                                                            .stationName
                                                      : ""
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      !item.userInfo.userName &&
                                                      !item.userInfo
                                                        .stationName,
                                                    expression:
                                                      "!item.userInfo.userName&&!item.userInfo.stationName",
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.userInfo.userCode)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ])
                                : _vm._e(),
                              item.scene === "team"
                                ? _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "t-ellipsis l-h-1-6-em m-r-10",
                                      },
                                      [_vm._v(_vm._s(item.userInfo.name))]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedSessionsID,
                            expression: "selectedSessionsID",
                          },
                        ],
                        staticClass:
                          "p-absolute top-0 right-0 bottom-0 left-0 o-0 w-100-p h-100-p",
                        attrs: { name: "Fruit", type: "checkbox" },
                        domProps: {
                          value: item.id,
                          checked: Array.isArray(_vm.selectedSessionsID)
                            ? _vm._i(_vm.selectedSessionsID, item.id) > -1
                            : _vm.selectedSessionsID,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = _vm.selectedSessionsID,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = item.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedSessionsID = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedSessionsID = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedSessionsID = $$c
                              }
                            },
                            function ($event) {
                              return _vm.itemClickEvent(item)
                            },
                          ],
                        },
                      }),
                      _vm.selectedSessionsID.includes(item.id)
                        ? _c("i", { staticClass: "d-inline-block m-t-22" }, [
                            _c("img", {
                              staticStyle: { width: "22px", height: "22px" },
                              attrs: {
                                src: require("@/assets/images/im/selectedSession@2x.png"),
                              },
                            }),
                          ])
                        : _c("i", { staticClass: "d-inline-block m-t-22" }, [
                            _c("img", {
                              staticStyle: { width: "22px", height: "22px" },
                              attrs: {
                                src: require("@/assets/images/im/unSelectedSession@2x.png"),
                              },
                            }),
                          ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }